import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { useTbodyPosition } from '../../../../../utils/hooks/useTbodyPosition';
import { generateTableBody } from '../../../helpers';

const Body = ({ isLoading, items }) => {
  const bodyRef = useRef(null);
  const position = useTbodyPosition({ bodyRef, count: items?.length, bodyHeight: '200px' });

  return (
    <tbody
      className={classNames('', { 'tbody-loading': isLoading })}
      style={{ backgroundPositionY: position.y, backgroundPositionX: position.x }}
      ref={bodyRef}
    >
      {items?.map((item) => (
        <tr key={item.id}>
          {generateTableBody('referrals', item)?.map((element) => {
            switch (element.type) {
            case 'payments':
              return (
                <td key={element.type} className={element.class} {...element.attrs}>
                  {item.payments !== 0 ? (
                    <Link to={`/payments?query=${item.affiliate}&search_type=8`}>{element.value}</Link>
                  ) : (
                    <span>{element.value}</span>
                  )}
                </td>
              );

            default:
              return (
                <td key={element.type} className={element.class} {...element.attrs}>
                  {element?.value}
                </td>
              );
            }
          })}
        </tr>
      ))}
    </tbody>
  );
};

Body.propTypes = {
  isLoading: PropTypes.bool,
  items: PropTypes.array,
};

export default Body;
